import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import './footer.css';
// deixa de ser burro e troca esse ano por algo dinâmico

const getCurrentYear = () => new Date().getFullYear();

const Footer = () => {

  return (
    <div className="footer-box">
      <AnimationOnScroll animateIn="slide-in-fwd-bottom" offset={1250} duration={0.7} delay={300}>
        <footer className="psico__footer">
          <div className="psico__footer-content">
            <p>©{getCurrentYear()}, Psicólogo André Parreira (06/197081) – Todos os direitos reservados |</p>
            <p><a href="mailto:guilhermesantosdegodoy@gmail.com">Dev by Guilherme de Godoy</a></p>
          </div>

          <div className="psico__footer-content__broken">
            <p>©{getCurrentYear()}, Psicólogo André Parreira (06/197081) –</p>
            <p>Todos os direitos reservados |</p>
            <a href="mailto:guilhermesantosdegodoy@gmail.com">Dev by Guilherme de Godoy</a>
          </div>

          <div className="psico__footer-content__brokenMiddle">
            <p>©{getCurrentYear()}, Psicólogo André Parreira (06/197081) – Todos os direitos reservados |</p>
            <p><a href="mailto:guilhermesantosdegodoy@gmail.com">Dev by Guilherme de Godoy</a></p>
          </div>
        </footer>
      </AnimationOnScroll>
    </div>
  );
};

export default Footer;
